import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9h2zm-6 7h-2v-4l-2 3-2-3v4H8v-7h2l2 3 2-3h2v7z"
}), 'MuseumSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MuseumSharp.js
// module id = 4959
// module chunks = 2